import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";
import {FormControl, Validators} from "@angular/forms";
import { FormControlValidators } from "../../../models/validators/validator";
import { Site } from "../../../models/support.model";
import { PromopultBalanceActionTypes, SupportService } from "../support.service";
import { HelperService } from "../../../lib/helper.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalSpreaderService } from "./modal_spreader_service";
import { AuthService } from "../../../auth.service";

@Component({
	template: `
		<base-support-modal
			[title]="title"
			[btnOkClass]="'btn-warning'"
			[btnOkLabel]="'Установить'"
			(onOk)="ok()"
			[form]="form"
		>
			<div
				class="alert alert-danger"
				role="alert"
				*ngIf="site.promopult"
			>
				Зачисление денег произойдёт в сервис продвижения сайтов Promopult!<br/>
				Сумма указывается в рублях!
			</div>
			
			<div
				class="row"
				*ngIf="site.promopult; else noPromopultUser"
			>
				<div class="col-12">
					Баланс {{ site.promopult.balance }} {{ helper.currencyLabels['rub'] }}
				</div>

				<div class="col-12">
					Статус
					<span class="badge badge-{{ site.promopult.status === 'run' ? 'success' : 'warning' }}">
						{{ site.promopult.status }}
					</span>
				</div>
			</div>
			
			
			<ng-template #noPromopultUser>
				<div class="alert alert-danger" role="alert">
					У сайта нет промопульт-аккаунта
				</div>
			</ng-template>
			
			<hr/>
			
			<div [formGroup]="form">
				<div class="form-group">
					<h5>
						Тип операции
					</h5>
					
					<div class="form-check">
						<label class="form-check-label">
							<input
								class="form-check-input" type="radio"
								formControlName="type"
								value="increase"
							>

							пополнить
						</label>
					</div>
					<div class="form-check">
						<label class="form-check-label">
							<input
								class="form-check-input" type="radio"
								formControlName="type"
								value="decrease"
							>

							уменьшить
						</label>
					</div>
				</div>
				
				<div class="form-row">
					<div class="col-2">
						<h5>
							Сумма
						</h5>
					</div>
					
					<div class="col-8">
						<input
							type="number"
							class="form-control"
							formControlName="amount"
							[formErrorIndicator]="form.get('amount')"
						/>
					</div>
					
					<div class="col-2">
						руб.
					</div>
				</div>
			</div>
		</base-support-modal>

	`
})
export class PromoputlModalComponent extends BaseSupportModalComponent {
	title: string;
	site: Site;
	
	amount: number = 0;
	type: string = 'increase';
	
	constructor(
		public activeModal: NgbActiveModal,
		public supportService: SupportService,
		public spreader: ModalSpreaderService,
		public helper: HelperService,
		public authService: AuthService,
	) {
		super(activeModal, supportService, spreader);
	}

	ngOnInit() {
		this.spreader.base.form = this.form;

		this.form.addControl(
			'type',
			new FormControl(
				this.type,
			)
		);
		
		this.form.addControl(
			'amount',
			new FormControl(
				this.amount,
				[
					FormControlValidators.gte(1),
					FormControlValidators.lte(250000)
				]
			)
		);

		if ( ! this.site.promopult) {
			this.form.setErrors({
				'noPromopult': {
					value   : null,
					i18n    : 'validator error.required',
					message : 'У сайта нет промопульт-аккаунта',
					params  : null,
				}
			});

			return ;
		}
		
		this.form.valueChanges.subscribe(({ amount, type }) => {
			this.amount = amount;
			this.type = type;
		});
	}

	async ok() {
		if (
			confirm(
				`Подтвердите ${this.actionName()} баланса промопульта сайта ${this.site.domainUrl} на ${this.amount} рублей?`
			)
		) {
			const { INCREASE, DECREASE } = PromopultBalanceActionTypes;
			const { userId: supportId } = this.authService;

			await this.supportService.updateBalancePromopultBalance(
				this.site._id,
				this.type === 'increase' ? INCREASE : DECREASE,
				this.amount,
				this.spreader.base.comment,
				supportId,
			).toPromise();
			
			this.execute();
		}
	}
	
	actionName() {
		return  this.type === 'increase' ? 'пополнения' : 'уменьшения';
	}
}
